import React, { useState, useEffect } from 'react'
import { siteApi, categoryApi } from '../services/api'

const ToolsSection = () => {
  const [sites, setSites] = useState([])
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      setLoading(true)
      const [sitesRes, categoriesRes] = await Promise.all([
        siteApi.list(),
        categoryApi.list('tool')
      ])
      
      if (sitesRes.code === 0) setSites(sitesRes.data)
      if (categoriesRes.code === 0) setCategories(categoriesRes.data)
    } catch (err) {
      setError('加载数据失败')
    } finally {
      setLoading(false)
    }
  }

  const getSitesByCategory = (categoryId) => {
    return sites.filter(site => site.category_id === categoryId)
  }

  const renderToolIcon = (site) => {
    // Base64 图片（兼容旧数据）
    if (site.icon && site.icon.startsWith('data:image')) {
      return <img src={site.icon} alt={site.name} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
    }
    // URL 图片（新数据）
    if (site.icon && site.icon.startsWith('http')) {
      return <img src={site.icon} alt={site.name} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
    }
    // emoji 或默认图标
    return site.icon || '🤖'
  }

  if (loading) {
    return (
      <section className="section">
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>加载中...</p>
        </div>
      </section>
    )
  }

  if (error) {
    return (
      <section className="section">
        <div className="error">{error}</div>
      </section>
    )
  }

  return (
    <section className="section">
      <div className="section-header">
        <span className="section-title">常用 AI 工具网站</span>
        <span className="section-count">// 精选收录</span>
      </div>
      
      {categories.map(category => {
        const categorySites = getSitesByCategory(category.id)
        if (categorySites.length === 0) return null
        
        return (
          <div key={category.id}>
            <div className="category-label">{category.name}</div>
            <div className="card-grid grid-3">
              {categorySites.map((site, index) => (
                <a 
                  key={site.id} 
                  href={site.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="tool-card card-anim"
                  style={{ animationDelay: `${index * 0.05}s` }}
                >
                  <div 
                    className="tool-icon" 
                    style={{ background: site.bg_color || 'linear-gradient(135deg,#63b3ed20,#63b3ed40)' }}
                  >
                    {renderToolIcon(site)}
                  </div>
                  <div className="tool-info">
                    <div className="tool-name">{site.name}</div>
                    <div className="tool-desc">{site.description}</div>
                    {site.tag_name && (
                      <span 
                        className="tool-tag" 
                        style={{ color: site.tag_color, borderColor: `${site.tag_color}4d` }}
                      >
                        {site.tag_name}
                      </span>
                    )}
                  </div>
                </a>
              ))}
            </div>
          </div>
        )
      })}
    </section>
  )
}

export default ToolsSection
